import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginCallbackComponent } from './pages/login/login-callback/login-callback.component';
import { BaseComponent } from './app-layout/base/base.component';
import { authGuard } from './guards/auth.guard';
import { SchoolIndexComponent } from './pages/school/school-index/school-index.component';
import { SchoolDetailComponent } from './pages/school/school-detail/school-detail.component';
import { UserIndexComponent } from './pages/user/user-index/user-index.component';
import { UserDetailComponent } from './pages/user/user-detail/user-detail.component';
import { CourseInformationFormComponent } from './components/course-information-form/course-information-form.component';
import { CourseIndexComponent } from './pages/course/course-index/course-index.component';
import { CourseDetailComponent } from './pages/course/course-detail/course-detail.component';
import { AuthorsIndexComponent } from './pages/settings/authors-index/authors-index.component';
import { StudiesIndexComponent } from './pages/settings/studies-index/studies-index.component';
import { StudyLevelsIndexComponent } from './pages/settings/study-levels-index/study-levels-index.component';
import { SubjectsIndexComponent } from './pages/settings/subjects-index/subjects-index.component';
import { ProductIndexComponent } from './pages/product/product-index/product-index.component';
import { ProductDetailComponent } from './pages/product/product-detail/product-detail.component';
import { PeriodsIndexComponent } from './pages/settings/periods-index/periods-index.component';
import { ClientsIndexComponent } from './pages/clients/clients.component';
import { OrderIndexComponent } from './pages/order/order-index/order-index.component';
import { OrderDetailsComponent } from './pages/order/order-details/order-details.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { QueueMessageIndexComponent } from './pages/queue-message/queue-message-index/queue-message-index.component';
import { TemplatesIndexComponent } from './pages/settings/templates-index/templates-index.component';
import { PlatformStatusComponent } from './pages/platform-status/platform-status.component';

export const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    children: [
      {
        path: '',
        component: DashboardComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard]
      },
      {
        path: 'clients',
        component: ClientsIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'platform-status',
        component: PlatformStatusComponent,
        canActivate: [authGuard]
      },
      {
        path: 'orders',
        component: OrderIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'orders/details/:id',
        component: OrderDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'school/list',
        component: SchoolIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'school/details/:id',
        component: SchoolDetailComponent,
        canActivate: [authGuard]
      },
      {
        path: 'user/list',
        component: UserIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'user/details/:id',
        component: UserDetailComponent,
        canActivate: [authGuard]
      },
      {
        path: 'course/list',
        component: CourseIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'course/details/:id',
        component: CourseDetailComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/authors',
        component: AuthorsIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/studies',
        component: StudiesIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/studyLevels',
        component: StudyLevelsIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/subjects',
        component: SubjectsIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/periods',
        component: PeriodsIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'settings/templates',
        component: TemplatesIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'product/list',
        component: ProductIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'product/details/:id',
        component: ProductDetailComponent,
        canActivate: [authGuard]
      },
      {
        path: 'queue-messages/list',
        component: QueueMessageIndexComponent,
        canActivate: [authGuard]
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard]
      }
    ]
  },
  {
    path: 'callback',
    component: LoginCallbackComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'not-logged-in',
    redirectTo: ''
  },
  {
    path: 'is-logged-in',
    component: LoginComponent,
  }
];